// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.next-game_next-game__OZ\\+iD {
  display: grid;
  grid-template-rows: repeat(4, min-content);
  padding: 20px;
  gap: 24px;
  background-color: var(--primary-background-color);
  border: 1px solid var(--primary-border-color);
  border-radius: 6px;
  max-width: 511px;
}

.next-game_game-header__grNca {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 24px;
}

.next-game_game-info__QdsR5 {
  display: grid;
  grid-template-rows: repeat(2, auto);
  gap: 4px;
}

.next-game_game-time__NYPOT {
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  gap: 4px;
}

.next-game_game-body__Z-XRD {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: 1fr auto 1fr;
  gap: 48px;
}

.next-game_game-team__ePXGH {
  display: grid;
  gap: 12px;
  text-align: center;

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.next-game_versus__4doXD {
  font-size: 32px;
  font-weight: 1000;
}

.next-game_actions__7oBVU {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 12px;
}

.next-game_team-logo__Euz2K {
  margin: auto;
}

@media (max-width: 980px) {
  .next-game_game-body__Z-XRD {
    gap: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/next-game.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,SAAS;EACT,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;;EAElB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".next-game {\n  display: grid;\n  grid-template-rows: repeat(4, min-content);\n  padding: 20px;\n  gap: 24px;\n  background-color: var(--primary-background-color);\n  border: 1px solid var(--primary-border-color);\n  border-radius: 6px;\n  max-width: 511px;\n}\n\n.game-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: start;\n  gap: 24px;\n}\n\n.game-info {\n  display: grid;\n  grid-template-rows: repeat(2, auto);\n  gap: 4px;\n}\n\n.game-time {\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  align-items: center;\n  gap: 4px;\n}\n\n.game-body {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 48px;\n}\n\n.game-team {\n  display: grid;\n  gap: 12px;\n  text-align: center;\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.versus {\n  font-size: 32px;\n  font-weight: 1000;\n}\n\n.actions {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 12px;\n}\n\n.team-logo {\n  margin: auto;\n}\n\n@media (max-width: 980px) {\n  .game-body {\n    gap: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"next-game": `next-game_next-game__OZ+iD`,
	"game-header": `next-game_game-header__grNca`,
	"game-info": `next-game_game-info__QdsR5`,
	"game-time": `next-game_game-time__NYPOT`,
	"game-body": `next-game_game-body__Z-XRD`,
	"game-team": `next-game_game-team__ePXGH`,
	"versus": `next-game_versus__4doXD`,
	"actions": `next-game_actions__7oBVU`,
	"team-logo": `next-game_team-logo__Euz2K`
};
export default ___CSS_LOADER_EXPORT___;
